import api from "./client"
import type { Appointment, Client } from "../types"

export async function getAppointments(params?: {
  start_date?: string
  end_date?: string
}): Promise<Appointment[]> {
  const { data } = await api.get<Appointment[]>("/appointments", { params })
  return data
}

export async function createAppointment(
  params: Record<string, unknown>
): Promise<Appointment> {
  const { data } = await api.post<Appointment>("/appointments", {
    appointment: params,
  })
  return data
}

export async function updateAppointment(
  id: number,
  params: Record<string, unknown>
): Promise<Appointment> {
  const { data } = await api.patch<Appointment>(`/appointments/${id}`, {
    appointment: params,
  })
  return data
}

export async function deleteAppointment(id: number): Promise<void> {
  await api.delete(`/appointments/${id}`)
}

export async function getAvailableClients(
  clientType?: string
): Promise<Client[]> {
  const { data } = await api.get<Client[]>("/appointments/available_clients", {
    params: { client_type: clientType },
  })
  return data
}

export interface CalendarRoutine {
  id: number
  name: string
  scheduled_day: number // 0=Sun, 1=Mon, ..., 6=Sat
  start_hour: number
  end_hour: number
  user_id: number
  user: { id: number; name: string; email: string; role: string; client_type?: string }
}

export async function getCalendarRoutines(params: {
  start_date: string
  end_date: string
}): Promise<CalendarRoutine[]> {
  const { data } = await api.get<CalendarRoutine[]>("/appointments/calendar_routines", { params })
  return data
}

export async function checkAvailability(params: {
  date: string
  hour: number
  exclude_appointment_id?: number
}): Promise<{ count: number; max: number; available: boolean }> {
  const { data } = await api.get("/appointments/check_availability", { params })
  return data
}
